<template>
  <div class="background" :style="backgroundSettings">
    <!-- <img src="@/assets/images/kachel1.png" /> -->
    <!-- <div :style="tile"></div> -->
    <div
      id="productInfoButton"
      @click="showProductInfo"
      v-if="isStartPage"
    ></div>
    <div>
      <div v-for="tile in tiles" :key="tile.backgroundImage">
        <div class="tile" :style="tile.style" @click="tileClicked(tile)" />
      </div>
    </div>
    <div id="overlayBottomRight" v-if="!isStartPage">
      <img
        src="@/assets/ZURUECK.png"
        style="width: 7%"
        alt="Back Button"
        @click="backClicked()"
      />
    </div>
    <div id="overlayBottomRightInfo" style="z-index: 100" v-if="infoImage">
      <img
        src="@/assets/button-information.png"
        style="width: 3%"
        alt="Back Button"
        @click="showInfo()"
      />
    </div>
    <div id="productInfoOverlay" v-if="productInfoVisible">
      <div style="margin: 5%">
        <h1>LRinfomanager Informationen</h1>
        <h2>Version: {{ productInfoData.version }}</h2>
        <h2>Darstellung eines Bildes vom Server</h2>
        <img
          :src="productInfoData.remoteImagePath"
          style="width: 20%; height: 20%"
        />

        <div id="overlayBottomRight">
          <img
            src="@/assets/ZURUECK.png"
            style="width: 7%"
            alt="Back Button"
            @click="productInfoVisible = false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuSettings from "../MenuSettings";

// const version = require("root-require")("./package.json").version;

export default {
  name: "Menu",
  components: {},
  data() {
    return {
      backgroundSettings: {
        backgroundImage:
          menuSettings.pageSettings[this.$route.params.page].backgroundImage,
      },
      tiles: menuSettings.pageSettings[this.$route.params.page].tiles,
      backDestinationName:
        menuSettings.pageSettings[this.$route.params.page].backDestinationName,
      backDestinationParam:
        menuSettings.pageSettings[this.$route.params.page].backDestinationParam,

      infoImage: menuSettings.pageSettings[this.$route.params.page].infoImage,

      productInfoVisible: false,

      productInfoData: {
        version: process.env.APPLICATION_VERSION,
        remoteImagePath:
          "https://my.lrinfomanager.com/data/zeile-1_1_Ein_kraftvolles_Immunssystem/Produkte/Immunssystem_AloeVera_Tinkgel_Honey_seite02.jpg",
      },
    };
  },
  computed: {
    isStartPage: function () {
      return this.$route.params.page === "startScreen";
    },
  },
  methods: {
    backClicked() {
      // usageStatisticsService.sendUsage(this.$route.params.page, this.backDestinationParam);
      console.log(this.backDestinationName + " " + this.backDestinationParam);
      this.$router.push({
        name: this.backDestinationName,
        params: { page: this.backDestinationParam },
      });
    },
    showInfo() {
      this.$router.push({
        name: "slidepage",
        params: { page: this.infoImage },
      });
    },
    tileClicked(tile) {
      if (tile.action === "menu") {
        if (tile.actionParam) {
          this.$router.push({
            name: "tilepage",
            params: { page: tile.actionParam },
          });
        } else {
          console.log("Keine Action definiert");
        }
      } else if (tile.action === "slides") {
        if (tile.actionParam) {
          this.$router.push({
            name: "slidepage",
            params: { page: tile.actionParam },
          });
        } else {
          console.log("Keine Action definiert");
        }
      } else if (tile.action === "product") {
        if (tile.actionParam) {
          this.$router.push({
            name: "productpage",
            params: { page: tile.actionParam },
          });
        } else {
          console.log("Keine Action definiert");
        }
      } else if (tile.action === "video") {
        if (tile.actionParam) {
          this.$router.push({
            name: "videopage",
            params: { page: tile.actionParam },
          });
        } else {
          console.log("Keine Action definiert");
        }
      }
    },
    showProductInfo() {
      this.productInfoVisible = true;
    },
  },
  beforeRouteUpdate: function (to, from, next) {
    this.backgroundSettings.backgroundImage =
      menuSettings.pageSettings[to.params.page].backgroundImage;
    this.tiles = menuSettings.pageSettings[to.params.page].tiles;

    this.backDestinationName =
      menuSettings.pageSettings[to.params.page].backDestinationName;
    this.backDestinationParam =
      menuSettings.pageSettings[to.params.page].backDestinationParam;

    this.infoImage = menuSettings.pageSettings[to.params.page].infoImage;

    next();
  },
  created() {},
};
</script>

<style scoped>
.background {
  width: 100%;
  height: 100%;
  background-size: contain;
}

.tile {
  position: absolute;
  width: 16.6%;
  height: 17%;
  background-size: contain;
}

#overlayBottomRight {
  position: absolute;
  bottom: 2%;
  /* background: rgba(0, 0, 0, 0.5); */
  width: 100%;
  right: 2%;
  text-align: right;
}

#overlayBottomRightInfo {
  position: absolute;
  bottom: 2%;
  /* background: rgba(0, 0, 0, 0.5); */
  width: 90%;
  /* padding: 30px; */
  text-align: right;
}

#productInfoButton {
  position: absolute;
  top: 4%;
  right: 4%;
  width: 20%;
  height: 10%;
  /* background-color: red; */
}

#productInfoOverlay {
  position: absolute;
  top: 5%;
  right: 5%;
  width: 90%;
  height: 90%;
  background-color: rgba(200, 200, 200, 0.9);
}
</style>